import { format } from "date-fns/esm";
import { LazyLoadImage } from "react-lazy-load-image-component";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  formatMoney,
  getEligibilityLines,
  getOrderItemCount,
  getOrderTotal,
  isOrderActionable,
  isOrderTrackable,
} from "./utils";

function OrderCard({ order, rmsConfig, onSelect }) {
  const actionable = isOrderActionable(order);
  const trackable = isOrderTrackable(order);
  const canOpen = actionable || trackable;
  const itemCount = getOrderItemCount(order);
  const allImages = order.order_items || [];
  const visibleImages = allImages.slice(0, 4);
  const hiddenImageCount = Math.max(0, allImages.length - 4);
  const eligibilityLines = getEligibilityLines(order, rmsConfig);

  return (
    <button
      type="button"
      className={`order-card${trackable ? " trackable" : ""}`}
      disabled={!canOpen}
      onClick={() => {
        if (actionable) {
          onSelect(order);
        } else if (trackable) {
          onSelect(order);
        }
      }}
    >
      <div className="order-card-header">
        <div className="order-main">
          <p className="order-number">Order {order.order_name}</p>
          <div className="order-dates">
            {order.order_created_at && (
              <div>
                Placed on{" "}
                {format(new Date(order.order_created_at), "dd MMM yyyy")}
              </div>
            )}
            {order.delivered_at && (
              <div>
                Delivered on{" "}
                {format(new Date(order.delivered_at), "dd MMM yyyy")}
              </div>
            )}
          </div>
        </div>
        <div className="order-meta">
          <div className="order-price">{formatMoney(getOrderTotal(order))}</div>
          <div className="order-count">
            {itemCount} item{itemCount === 1 ? "" : "s"}
          </div>
        </div>
      </div>

      <div className="order-images">
        {visibleImages.map((product, index) => (
          <span className="order-image-wrap" key={`${order.order_id}-${index}`}>
            <LazyLoadImage
              src={product?.parent_image_url || product.image_url}
              alt={product.product_title || "Order item"}
              effect="opacity"
            />
            {hiddenImageCount > 0 && index === 3 && (
              <span className="order-image-overlay">+{hiddenImageCount}</span>
            )}
          </span>
        ))}
      </div>

      <div className="order-divider" />
      <div className="order-footer">
        <span
          className={`eligibility ${
            actionable ? "eligible" : trackable ? "trackable" : ""
          }`}
        >
          {actionable ? <CheckCircleOutlineIcon /> : <InfoOutlinedIcon />}
          <span className="eligibility-copy">
            {eligibilityLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </span>
        </span>
        {canOpen ? (
          <span className="view-order">
            {trackable ? "Track Order" : "View Order"}
            <KeyboardArrowRightIcon />
          </span>
        ) : null}
      </div>
    </button>
  );
}

export default OrderCard;
